import t from './locales';

document.addEventListener('turbolinks:load', () => {
  handleToggleCheckBoxButton();
  handleVoucherCheckbox();
  handleLoadingModal();
  handleDisplayResortSelectModal();
  handleExternalExchangeLink();
  handleClickBulkRip();

  const queryString = window.location.search;
  const params = new URLSearchParams(queryString);
  if (params.get('qr_failed') === 'true') {
    $('#modal-qr-failed').modal();
  }

  if (params.get('charged_voucher_id')) {
    $('#modal-successfully-charged').modal();
  }
});

const handleToggleCheckBoxButton = () => {
  const toggleCheckBoxesButtons = document.getElementsByClassName('voucher-list-modal__toggle-checkbox-button');
  for (const toggleCheckBoxesButton of Array.from(toggleCheckBoxesButtons)) {
    toggleCheckBoxesButton.addEventListener('change', (event) => {
      // 「まとめて使用」ボタンを押した時にチェックボックスを表示する
      const isChecked = event.target.checked;
      const voucherMasterId = event.target.value;
      const checkBoxes = document.getElementsByClassName(`voucher-master-${voucherMasterId}-checkbox`);
      const actionButtons = document.getElementsByClassName(`voucher-master-${voucherMasterId}-action-button`);
      const bulkActionButton = document.getElementById(`voucher-master-${voucherMasterId}-bulk-action-button`);
      for (const checkBox of checkBoxes) {
        if (isChecked) {
          checkBox.classList.remove('d-none');
          checkBox.closest('.voucher-list-modal__voucher-item').classList.add('-checked');
          if (checkBox.getElementsByClassName('voucher-check-box')[0]) {
            checkBox.getElementsByClassName('voucher-check-box')[0].checked = true;
          }
        } else {
          checkBox.classList.add('d-none');
          checkBox.closest('.voucher-list-modal__voucher-item').classList.remove('-checked');
          if (checkBox.getElementsByClassName('voucher-check-box')[0]) {
            checkBox.getElementsByClassName('voucher-check-box')[0].dispatchEvent(new Event('change'));
            checkBox.getElementsByClassName('voucher-check-box')[0].checked = false;
          }
        }
      }

      handleBulkButtonContent();

      for (const button of actionButtons) {
        if (isChecked) {
          button.classList.add('d-none');
        } else {
          button.classList.remove('d-none');
        }
      }
      if (isChecked) {
        bulkActionButton.classList.remove('d-none');
      } else {
        bulkActionButton.classList.add('d-none');
      }

      // チェック済みのスタイルを当てるためにクラスを付与
      const parentVoucherListElement = event.target.closest('.voucher-list-modal__voucher-list');
      if (isChecked) {
        parentVoucherListElement.classList.add('-checked');
      } else {
        parentVoucherListElement.classList.remove('-checked');
      }

      // 他のチケットリストを非活性にする
      const voucherListElements = Array.from(
        document.getElementById('vouchers-modal-active-vouchers').getElementsByClassName('voucher-list-modal__voucher-list')
      );
      for (const el of voucherListElements) {
        if (el === parentVoucherListElement) {
          continue;
        }

        if (isChecked) {
          const toggleButton = el.getElementsByClassName('voucher-list-modal__voucher-list__toggle-button')[0];
          if (toggleButton && !toggleButton.classList.contains('collapsed')) {
            toggleButton.click();
          }

          el.classList.add('-disabled');
          el.style.pointerEvents = 'none';
        } else {
          el.classList.remove('-disabled');
          el.style.pointerEvents = 'auto';
        }
      }
    });
  }
};

// チェックボックスが変更された時に、選択されたチケットとスキー場選択モーダルの枚数を表示する
const handleVoucherCheckbox = () => {
  const voucherCheckBoxes = Array.from(document.getElementsByClassName('voucher-check-box'));

  for (const voucherCheckBox of voucherCheckBoxes) {
    voucherCheckBox.addEventListener('change', (event) => {
      handleBulkButtonContent();

      // チェック済みのスタイルを当てるためにクラスを付与
      const voucherItemElement = event.target.closest('.voucher-list-modal__voucher-item');
      if (event.target.checked) {
        voucherItemElement.classList.add('-checked');
      } else {
        voucherItemElement.classList.remove('-checked');
      }
    });
  }
};

const handleBulkButtonContent = () => {
  const bulkActionButton = document.getElementById('bulk-action-button');
  const bulkActionButtonAllCount = document.getElementById('bulk-action-button-all-count');
  const bulkExchangeModal = document.getElementById('modal-bulk-external-exchange');
  const modalAllCount = bulkExchangeModal.getElementsByClassName('voucher-bulk-select-resort-modal__detail__all-count')[0];
  const bulkActionButtonEachCount = document.getElementById('bulk-action-button-each-count');
  const modalEachCount = bulkExchangeModal.getElementsByClassName('voucher-bulk-select-resort-modal__detail__each-count')[0];
  const voucherCheckBoxes = Array.from(document.getElementsByClassName('voucher-check-box'));

  // チェックされているチケットの総数を表示
  const checked = voucherCheckBoxes.filter((checkBox) => checkBox.checked);
  if (checked.length > 0) {
    bulkActionButton.classList.remove('d-none');
  } else {
    bulkActionButton.classList.add('d-none');
  }
  const voucherCount = checked.length;
  bulkActionButtonAllCount.textContent = t.vouchersSelected({ number: voucherCount });
  modalAllCount.textContent = t.qrCodesInTotal({ number: voucherCount });

  // チェックされているチケットの人数ごとの枚数を表示
  const voucherCountGroupByPersonType = checked.reduce((acc, checkBox) => {
    const person_type = checkBox.nextElementSibling.value;
    const count = acc[person_type] || 0;
    acc[person_type] = count + 1;
    return acc;
  }, {});

  for (const child of bulkActionButtonEachCount.children) {
    child.remove(); // 既存の要素を一度削除
  }
  for (const child of modalEachCount.children) {
    child.remove(); // 既存の要素を一度削除
  }

  // DOMを上書きする前に一度削除することで重複表示を制御
  bulkActionButtonEachCount.innerHTML = '';
  modalEachCount.innerHTML = '';

  for (const key of Object.keys(voucherCountGroupByPersonType)) {
    const element1 = document.createElement('div');
    element1.textContent = `${key} ${t.voucherCount({ number: voucherCountGroupByPersonType[key] })}`;
    element1.classList.add('text-sm');
    bulkActionButtonEachCount.appendChild(element1);

    const element2 = document.createElement('div');
    element2.textContent = `${key}${t.voucherCount({ number: voucherCountGroupByPersonType[key] })}`;
    element2.classList.add('ml-2');
    modalEachCount.appendChild(element2);
  }
};

// 共通券で、QR着券のスキー場を選択した後、スキー場選択用のモーダルを非表示にする
const handleDisplayResortSelectModal = () => {
  const qrSkiResorts = document.querySelectorAll('.qr_ski_resort');
  const resortSelectModals = document.querySelectorAll('.resort-select-modal');
  for (const qrSkiResort of qrSkiResorts) {
    qrSkiResort.addEventListener('click', () => {
      for (const rsm of resortSelectModals) {
        rsm.style.display = 'none';
      }
      const modalBackdrops = document.querySelectorAll('.modal-backdrop');
      for (const mbd of modalBackdrops) {
        mbd.style.display = 'none';
      }
    });
  }
};

const handleLoadingModal = () => {
  const elements = document.getElementsByClassName('generate-qr-code-link');
  for (const element of elements) {
    element.addEventListener('click', (event) => {
      const loadingModals = document.getElementsByClassName('exchange-display-block');
      for (const loadingModal of loadingModals) {
        loadingModal.style.display = 'block';
      }
      const exchangeModals = document.getElementsByClassName('exchange-display-none');
      for (const exchangeModal of exchangeModals) {
        exchangeModal.style.display = 'none';
      }
    });
  }
};

const handleExternalExchangeLink = () => {
  const moveToExternalExchangeButtons = document.getElementsByClassName('move-to-external-exchange-button');
  for (const element of moveToExternalExchangeButtons) {
    element.addEventListener('click', (event) => {
      setUrl(event.target.dataset.generateQrUrl, event.target.dataset.ripUrl);
    });
  }

  const moveToBulkExternalExchangeButtons = document.getElementsByClassName('move-to-bulk-external-exchange-button');
  for (const element of moveToBulkExternalExchangeButtons) {
    element.addEventListener('click', (event) => {
      setBulkUrl(event.target.dataset.voucherMasterId, event.target.dataset.resortCode, event.target.dataset.serviceName);
      setVoucherMasterIdData(event.target.dataset.voucherMasterId);

      const bulkExchangeModal = document.getElementById('modal-bulk-external-exchange');
      const resortNameElement = bulkExchangeModal.getElementsByClassName('voucher-bulk-select-resort-modal__detail__resort-name')[0];
      resortNameElement.textContent = t.redeemAtSkiResort({ resortName: event.target.dataset.resortName });
    });
  }
};

const setUrl = (generateQrUrl, ripUrl) => {
  const externalExchangeLinks = document.getElementsByClassName('generate-qr-code-link');
  const ripExchangeLinks = document.getElementsByClassName('rip-exchange-link');
  for (const externalExchangeLink of externalExchangeLinks) {
    externalExchangeLink.href = generateQrUrl;
  }
  for (const ripExchangeLink of ripExchangeLinks) {
    ripExchangeLink.href = ripUrl;
  }
};

const setBulkUrl = (voucherMasterId, resort_code, service_name) => {
  const voucherIds = selectedVoucherIds(voucherMasterId);
  const voucherIdsParams = voucherIds.map((voucherId) => `voucher_ids[]=${voucherId}`).join('&');
  const generateQrUrl = `/snow/me/vouchers/bulk/exchange?${voucherIdsParams}${resort_code ? `&resort_code=${resort_code}` : ''}`;
  const ripUrl = `/snow/me/vouchers/bulk/new?${voucherIdsParams}`;

  const bulkExchangeModal = document.getElementById('modal-bulk-external-exchange');
  const modalDetail = bulkExchangeModal.getElementsByClassName('voucher-bulk-select-resort-modal__detail')[0];
  modalDetail.children[0].textContent = service_name;

  setUrl(generateQrUrl, ripUrl);
};

const setVoucherMasterIdData = (voucherMasterId) => {
  const bulkExchangeModal = document.getElementById('modal-bulk-external-exchange');
  const bulkRipButton = bulkExchangeModal.getElementsByClassName('bulk-rip-button')[0];
  bulkRipButton.dataset.voucherMasterId = voucherMasterId;
};

const handleClickBulkRip = () => {
  const elements = document.getElementsByClassName('bulk-rip-button');
  for (const element of elements) {
    element.addEventListener('click', (event) => {
      const voucherIds = selectedVoucherIds(event.target.dataset.voucherMasterId);
      const params = voucherIds.map((voucherId) => `voucher_ids[]=${voucherId}`).join('&');
      const url = `/snow/me/vouchers/bulk/new?${params}`;
      window.location.href = url;
    });
  }
};

const selectedVoucherIds = (voucherMasterId) => {
  const checkBoxContainers = document.getElementsByClassName(`voucher-master-${voucherMasterId}-checkbox`);

  const checkedCheckBoxes = Array.from(checkBoxContainers)
    .map((container) => container.getElementsByClassName('voucher-check-box')[0])
    .filter((checkBox) => checkBox && checkBox.checked);

  return checkedCheckBoxes.map((checkBox) => checkBox.value);
};
